import { replaceContents } from '@utils/replaceContents';
import React from 'react';
import { NameSec, Dia, Bar, NameWrapper, LockSec } from './CoupleItemStyle';
import { ACCESS_TYPE_VALUE } from '@typings/common/accessType';
import LockIcon from '@template/GuardItem/LockIcon';

type Props = {
  textColor?: string;
  rightName: string;
  leftName: string;
  accessType: ACCESS_TYPE_VALUE;
};

function Name({ textColor, rightName, leftName, accessType }: Props) {
  return (
    <NameWrapper>
      <NameSec
        style={{ top: 8, left: 12, color: textColor || 'var(--textColor)' }}
      >
        <Dia color={textColor || ''} />
        <Bar
          style={{
            top: -10,
            left: -12,
            color: textColor || 'var(--textColor)',
          }}
        />
        <div dangerouslySetInnerHTML={{ __html: replaceContents(leftName) }} />
      </NameSec>

      <NameSec
        style={{
          bottom: 8,
          right: 12,
          color: textColor || 'var(--textColor)',
          textAlign: 'right',
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: replaceContents(rightName) }} />
        <Bar
          style={{
            bottom: -10,
            right: -12,
            color: textColor || 'var(--textColor)',
          }}
        />
        <Dia color={textColor || ''} />
      </NameSec>
      <LockSec>
        {accessType && <LockIcon direction="left" accessType={accessType} />}
      </LockSec>
    </NameWrapper>
  );
}

export default Name;
